import { DefaultError, useMutation } from '@tanstack/react-query';
import { updateHabitLifeAreaTaskOrder } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const useUpdateHabitLifeAreaTaskOrderMutation = () =>
  useMutation<void, DefaultError, { id: ID; taskIds: ID[] }>({
    mutationFn: async ({ id, taskIds }) =>
      updateHabitLifeAreaTaskOrder([{ lifeAreaId: id, taskIds }]),
  });
